// /* @flow */
import React, { type Node } from 'react';
import { ObjectsSortItem, ObjectsSortWrap, ObjectsSort, SortSvg } from './styled';
import { SortMin, SortMax } from '../Icons';

type TSortingItem = {
	title: string,
	type: string,
};

type TSortingProps = {
	sorting: TSortingItem[],
	active: string,
	direction: string,
	action: () => {},
};

const Sorting = ({ sorting, active, direction, action }: TSortingProps): Node => (
	<ObjectsSort>
		<ObjectsSortWrap>
			{sorting &&
				sorting.map((item: TSortingItem, idx) => (
					<ObjectsSortItem
						key={idx.toString()}
						onClick={() => action(item.type)}
						direction={direction}
						isActive={item.type === active}
					>
						{item.title}
						<SortSvg isActive={item.type === active} viewBox="0 0 24 24">
							{item.type === active && direction === 'up' ? SortMin : SortMax}
						</SortSvg>
					</ObjectsSortItem>
				))}
		</ObjectsSortWrap>
	</ObjectsSort>
);

export default Sorting;
